export const API_URL = "/api"
export const PAGE_SIZE = 20

export const NAMED_ENTITY_TYPES = [
  { value: "AUTHOR", label: "Creatore" },
  { value: "EDITOR", label: "Editore" },
  { value: "PRODUCER", label: "Produttore" },
  { value: "ARCHIVE", label: "Archivio" },
]

export const RECORD_MEDIA_TYPES = [
  { value: "CINEMA", label: "Cinema" },
  { value: "FOTOGRAFIA", label: "Fotografia" },
  { value: "LETTERATURA", label: "Letteratura" },
  { value: "TELEVISIONE", label: "Televisione" },
  { value: "WEB", label: "Web/Digitale" },
  { value: "INTERMEDIALE", label: "Intermediale" },
]

export const EVENT_TYPES = [
  { value: "ALLUVIONI", label: "Alluvioni" },
  { value: "FRANE", label: "Frane" },
  { value: "ERUZIONI", label: "Eruzioni" },
  { value: "TERREMOTI", label: "Terremoti" },
  { value: "MAREGGIATE", label: "Mareggiate" },
  { value: "VENTI", label: "Venti" },
]

export const COLLECTION_TYPES = [
    { value: "AREE", label: "Aree" },
    { value: "FENOMENI", label: "Fenomeni" },
    { value: "EVENTI", label: "Eventi" },
    { value: "COLLEZIONI", label: "Collezioni" },
]

export const OUTPUT_TYPES = [
  { value: "EVENTO", label: "Evento" },
  { value: "WORKSHOP", label: "Workshop" },
  { value: "RELAZIONE_SCIENTIFICA", label: "Relazione scientifica" },
]
